module.exports = __webpack_public_path__ + "img/dreams.f2bc29c.png";